export default class CustomTextDisplay {
  static createFactory(player) {
    return function customTextDisplayFactory() {
      return new CustomTextDisplay(player);
    };
  }

  currentValue = '';

  constructor(player) {
    this.player = player;

    this.update([]);
    this.isVisible = false;
  }

  update(cues) {
    this.cues = cues;
  }

  append(cues) {
    this.update([
      ...this.cues,
      ...cues.map(cue => ({
        startTime: cue.startTime,
        endTime: cue.endTime,
        text: cue.payload,
      })),
    ]);
  }

  destroy() {
    this.update([]);
    return Promise.resolve();
  }

  isTextVisible() {
    return this.isVisible;
  }

  updateSubtitles = () => {
    if (!this.isVisible && this.currentValue) {
      this.player.subtitlesElement.innerHTML = '';
      this.currentValue = '';
      return;
    }

    const currentTime = this.player.playerElement.currentTime;
    const subtitles = this.cues
      .filter(x => currentTime >= x.startTime && currentTime <= x.endTime)
      .map(cue => cue.text.replaceAll('\n', '<br/>'));

    const newValue = subtitles.join('\n');
    if (this.currentValue !== newValue) {
      this.player.subtitlesElement.innerHTML = newValue;
      this.currentValue = newValue;
    }
  }

  setTextVisibility(on) {
    this.isVisible = on;

    this.updateSubtitles();

    if (on) {
      this.player.addEventListener('ontimeupdate', this.updateSubtitles);
    } else {
      this.player.removeEventListener('ontimeupdate', this.updateSubtitles);
    }
  }

  remove(start, end) {
    this.update(this.cues.filter(cue => cue.startTime >= end || cue.endTime <= start));

    return true;
  }
}
